import { normalize as normalizeConversation } from 'models/conversation.model';
import { normalize as normalizeMessage } from 'models/message.model';
import { emit } from "infrastructure/eventHub";

export function registerChatSocketListeners(socket, repositories, userlogged) {
  
  /* Conversaciones */

  socket.on("assignedConversation", ({ user, conversation }) => {
    conversation = normalizeConversation(conversation);
    emit("chat", "conversation", "assigned", "local", {
      user,
      conversation
    });
  });

  socket.on("updatedConversation", async ({ conversation }) => {
    conversation = normalizeConversation(conversation);
    emit("chat", "conversation", "updated", "local", {
      conversation
    });
  });
  
  socket.on("closeConversation", ({ conversation }) => {
    conversation = normalizeConversation(conversation);
    emit("chat", "conversation", "close", "both", {
      conversation
    });
  });

  /* Mensajes */

  socket.on("messageSent", ({ message }) => {
    emit("chat", "message", "sent", "local", {
      message
    });
  });

  socket.on("messageStatusUpdate", ({ message }) => {
    emit("chat", "message", "statusUpdate", "local", {
      message
    });
  });

  socket.on("messageReceived", ({ message }, callback) => {
    message = normalizeMessage(message);
    emit("chat", "message", "received", "local", {
      message,
      callback
    });
  });

  /* Eventos */

  socket.on("chatCommentAdded", ({ comment }) => {
    emit("chat", "comment", "add", "local", {
      comment
    });
  });

  socket.on("event", ({ event }) => {
    emit("chat", "event", "add", "local", {
      event
    });
  });

  /* Conversaciones expiradas */

  socket.on("expiredConversationAssigned", ({ user, conversation }) => {
    conversation = normalizeConversation(conversation);
    emit("chat", "expiredConversation", "assigned", "local", {
      conversation
    });
  });

  /* Conversaciones sin asignar */

  socket.on("unassignedConversation", ({ conversation }) => {
    conversation = normalizeConversation(conversation);
    emit("chat", "unassignedConversation", "add", "local", {
      conversation
    });
  });
  
  socket.on("unassignedConversationAssigned", ({ conversation }) => {
    conversation = normalizeConversation(conversation);
    emit("chat", "unassignedConversation", "assigned", "local", {
      conversation
    });
  });

  /* Empleados */

  socket.on("updateEmployeeStatus", ({ user, status }) => {
    if(userlogged.uid === user.id) {
      emit("user", "status", "update", "both", {
        status
      });
    } else {
      repositories.agents.patch(user.id, { status });
    }
  });

}
